export const linkMap = {
    demonstrateUrl: 'https://jsj.top/f/HFe46V',
    onlineConsultationUrl: 'https://affim.baidu.com/unique_54447406/chat?siteId=20458549&userId=54447406&siteToken=351bfbeef4cc857f552b8114a57c9c93'
}